import { TailwindPlugin } from '@davincihealthcare/elty-design-system-foundations';
import plugin from 'tailwindcss/plugin';

import { tailwindZIndexExtend } from '@/tailwind.zIndex.tokens';

export const defaultPlugin = plugin(
  ({ addBase }) => {
    // eslint-disable-next-line no-undef
    addBase(require('./style.cjs'));
  },
  {
    plugins: [TailwindPlugin],
    theme: {
      extend: {
        zIndex: { ...tailwindZIndexExtend },
      },
    },
  },
);

export const pluginWithoutStyles = plugin(({ addBase }) => {
  // eslint-disable-next-line no-undef
  addBase(require('./style.cjs'));
});
